module.exports = __webpack_public_path__ + "static/media/three-hole-flat.7ea31ec0.webp";